import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";

type AlertColorType = "success" | "warning" | "error" | "info";
type RevisionActionType =
  | "cancelAccessRevision"
  | "blockAccessRevision"
  | "renovateAccessRevision";

@Component({
    selector: "pl-alert",
    templateUrl: "./alert.component.html",
    styleUrls: ["./alert.component.scss"],
    standalone: false
})
export class AlertComponent {
  @ContentChild("content", { static: true }) content!: HTMLElement;
  @ContentChild("header") header!: HTMLElement;

  @Input() close? = false;
  @Input() color?: AlertColorType | string = "info";
  @Input() display?: string;
  @Input() noIcon = "false";
  @Input() revision = "";
  @Input() isLoading = false;

  @Output() hasClosed = new EventEmitter();
  @Output() revisionAction = new EventEmitter<RevisionActionType>();

  public setIcon(color: string | undefined) {
    switch (color) {
      case "success":
        return "check_circle";
      case "info":
        return "info";
      case "error":
        return "error";
      case "warning":
        return "warning";
      default:
        return "info";
    }
  }

  keyboardClose(event: KeyboardEvent) {
    if (event.code === "Enter" || event.code === "Space") {
      event.preventDefault();
      this.hasClosed.emit();
    }
  }

  emitRevisionAction(action: RevisionActionType): void {
    this.revisionAction.emit(action);
  }
}
